import React from 'react';
import styled from 'styled-components';
import { ButtonSecondary, Type } from '@spotify-internal/encore-web';
import { TextDir } from './TextDir';
const OptionBubble = styled.div `
  background: #eeeeee;
  padding: 1rem;
  margin: 0;
  border-radius: 0.25rem;
  max-width: 80%;
  flex-grow: 0;
  width: 100%;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
const OptionTitle = styled.h4 `
  margin: 0;
  color: black;
`;
const OptionDescription = styled(Type) `
  color: black;
`;
export const OptionPill = styled(ButtonSecondary) `
  border: 1px solid #ccc;
  font-weight: 450;
  width: fit-content;
  &:enabled:hover {
    border: 1px solid black;
  }
`;
export const QuestionOption = ({ onClick, disabled, title, description, value, }) => (React.createElement(OptionBubble, null,
    React.createElement(OptionTitle, null,
        React.createElement(TextDir, null, title)),
    React.createElement(OptionDescription, null,
        React.createElement(TextDir, null, description)),
    React.createElement(OptionPill, { disabled: disabled, size: "small", onClick: onClick, "data-testid": "question-option" },
        React.createElement(TextDir, null, value))));
